module.exports = __webpack_public_path__ + "static/media/shelterWhite.59f217a7.svg";